import { Checkbox } from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { editAttributes } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function SelfPayReviewComplete() {
    const dispatch = useAppDispatch();
    const verify = useAppSelector((state) => state.verification.verification);
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
                color='primary'
                value={verify.verifyAttributes.selfPayReviewComplete}
                checked={verify.verifyAttributes.selfPayReviewComplete}
                onChange={(e) => dispatch(editAttributes(new ReduxUpdate('selfPayReviewComplete', e.target.checked)))}
            />
            <span style={{ userSelect: 'none', marginLeft: 4 }}>
                Self pay review completed.
            </span>
        </div>
    );
}

export { SelfPayReviewComplete }
